var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-editor',{staticClass:"advert-section",attrs:{"id":_vm.name,"name":_vm.name,"value":_vm.value,"disabled":_vm.disabled,"editorToolbar":_vm.customToolbar,"placeholder":_vm.placeholder},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }